export default "__VITE_ASSET__Zf1f2uIt__"